import { setSessionStorage } from '@zola-helpers/client/dist/es/util/storage';

import CrossSellPaper, { STD_HREF } from './CrossSellPaper';
import CrossSellWebsite, { WEBSITE_HREF } from './CrossSellWebsite';

const SESSION_TOKEN = 'marketplaceCStokenSRP';

/* select a cross-sell card component & props, based on provided values */
export const getAlternateCard = (cardNumber: number, token: string | null) => {
  let trackingProps = {
    cta_id: 'Cross Sell Website',
    cta: WEBSITE_HREF,
  };
  let component = CrossSellWebsite;
  if (token) {
    const tokenNumber = parseInt(token, 10) || 0;
    if (tokenNumber % 2 === 1) {
      component = CrossSellPaper;
      trackingProps = {
        cta_id: 'Cross Sell Paper',
        cta: STD_HREF,
      };
      setSessionStorage(SESSION_TOKEN, '0');
    } else {
      setSessionStorage(SESSION_TOKEN, '1');
    }
  } else {
    if (cardNumber === 0) {
      component = CrossSellPaper;
      trackingProps = {
        cta_id: 'Cross Sell Paper',
        cta: STD_HREF,
      };
    }
    setSessionStorage(SESSION_TOKEN, cardNumber.toString());
  }

  return { component, trackingProps };
};

const CrossSellUtils = {
  getAlternateCard,
};

export default CrossSellUtils;
